(function () {
  if (window.__editorialProductGridVideoInit) return;
  window.__editorialProductGridVideoInit = true;

  function bindVideoFallback(video) {
    if (!video || video.dataset.epgVideoBound === 'true') return;
    video.dataset.epgVideoBound = 'true';

    var fallback = video.getAttribute('data-video-src-fallback');
    if (!fallback) return;

    video.addEventListener('error', function onError() {
      if (video.getAttribute('src') !== fallback) {
        video.setAttribute('src', fallback);
        video.load();
      }
    });
  }

  /*
   * Autoplay diferido: el vídeo se renderiza con preload="none" para no descargar el MP4 durante la carga
   * de la página. Cuando la sección se acerca al viewport se activa la descarga y la reproducción
   * (silenciada), y se pausa al salir para ahorrar datos.
   */
  function tryPlay(video) {
    // Solo forzamos el silencio si el usuario no ha activado el sonido con los controles nativos.
    if (video.dataset.epgUserUnmuted !== 'true') video.muted = true;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function bindLazyAutoplay(video) {
    if (!video || video.dataset.epgAutoplayBound === 'true') return;
    video.dataset.epgAutoplayBound = 'true';

    // Los eventos play/pause llegan de forma asíncrona, así que marcamos una ventana temporal
    // tras cada acción programática para distinguirla de una pausa/reproducción del usuario.
    var programmaticUntil = 0;
    function markProgrammatic() {
      programmaticUntil = Date.now() + 1000;
    }
    function isProgrammatic() {
      return Date.now() < programmaticUntil;
    }

    video.addEventListener('pause', function () {
      if (!isProgrammatic() && !video.ended) video.dataset.epgUserPaused = 'true';
    });
    video.addEventListener('play', function () {
      if (!isProgrammatic()) video.dataset.epgUserPaused = 'false';
    });
    video.addEventListener('volumechange', function () {
      if (!video.muted) video.dataset.epgUserUnmuted = 'true';
    });

    function autoPlay() {
      if (video.dataset.epgUserPaused === 'true') return;
      if (video.preload !== 'auto') video.preload = 'auto';
      markProgrammatic();
      tryPlay(video);
    }

    function autoPause() {
      if (video.paused) return;
      markProgrammatic();
      video.pause();
    }

    if (!('IntersectionObserver' in window)) {
      autoPlay();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          autoPlay();
        } else {
          autoPause();
        }
      });
    }, { rootMargin: '200px 0px' });

    observer.observe(video);
  }

  function init() {
    document
      .querySelectorAll('.editorial-product-grid__video[data-video-src-fallback]')
      .forEach(bindVideoFallback);
    document
      .querySelectorAll('.editorial-product-grid__video[data-epg-autoplay="true"]')
      .forEach(bindLazyAutoplay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
